import React from 'react';
import { Table, Skeleton } from 'antd';
import type { ColumnsType } from 'antd/es/table';

interface TableSkeletonProps {
  columns: ColumnsType<any>;
  rows?: number;
}

// Add a loading skeleton on the base Table
const TableSkeleton: React.FC<TableSkeletonProps> = ({ columns, rows = 7 }) => {
  const skeletonColumns = columns.map((col) => ({
    ...col,
    render: () => <Skeleton.Input active size="small" block />,
  }));

  const data = Array.from({ length: rows }, (_, index) => ({ __skeletonKey: index }));

  return (
    <Table
      columns={skeletonColumns}
      dataSource={data}
      rowKey="__skeletonKey"
      pagination={false}
      rowClassName="table-row"
    />
  );
};

export default TableSkeleton;
